module.exports = __webpack_public_path__ + "img/1_1-commerciale-negozio-1.27b51bc8.png";